import React from "react";
import { useTranslation } from "../../context/TranslationContext";

const Refund = () => {
  const {
    refundTitle1,
    refundTitle2,
    refundP1Pre,
    refundP1Strong,
    refundP1Post,
    refundP2,
    refundP3,
  } = useTranslation();
  return (
    <div className="container lg:pb-36 pb-8  lg:mb-28 mb-8">
      <div className="flex lg:flex-nowrap flex-wrap lg:items-start items-center lg:justify-start justify-center">
        <div className="lg:w-1/2 w-full flex lg:items-start items-center lg:justify-start justify-center">
          <img
            src="/images/iade-image.png"
            className="object-contain w-[41.563rem] sm:h-[29.313rem] h-[12.5rem]"
          ></img>
        </div>
        <div className="lg:w-1/2 w-full flex flex-col lg:pl-12 lg:items-start items-center lg:justify-start justify-center lg:text-start text-center">
          <div className="flex flex-col mb-8">
            <span className="text-dark sm:text-[2.875rem] text-25 font-bold leading-[2.25rem]">
              {refundTitle1}
            </span>
            <span className="text-primary sm:text-[2.875rem] text-25 font-bold leading-[2.875rem]">
              {refundTitle2}
            </span>
          </div>
          <div className="flex flex-col fon-normal text-15 opacity-50">
            <p>
              {refundP1Pre} <strong>{refundP1Strong}</strong> {refundP1Post}
            </p>
            <p>
              <strong>{process.env.NEXT_PUBLIC_SITENAME}</strong> {refundP2}
            </p>
            <p>
              {refundP3.replace("{site}", process.env.NEXT_PUBLIC_SITENAME)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Refund;
